<section class="sh-dialog__content" tabindex="-1">
  @if (enableSuggestions) {
    <p>{{ "thesaurus.thesaurus-tree-dialog.add-suggestion-info" | translate }}</p>
  }
  @if (config.data?.message) {
    <p class="sh-clear-margin-top">
      <sh-html-parser [message]="config.data.message"></sh-html-parser>
    </p>
  }

  <ng-container *ngTemplateOutlet="selectMultiple ? multiple : single"></ng-container>
</section>
<footer class="sh-dialog__footer">
  <div class="sh-action-group -sh-align-end">
    <button type="button" class="sh-button sh-action-group__item" (click)="submit()" [disabled]="disableSubmit">{{ config.data.yes }}</button>
    <button type="button" class="sh-button--secondary sh-action-group__item" (click)="cancel()">{{ config.data.no }}</button>
  </div>
  <div class="sh-action-group -sh-align-end"></div>
</footer>

<ng-template #single>
  @if (thesaurusDefDottedKey) {
    <med-thesaurus-tree-single
      [thesaurusDefDottedKey]="thesaurusDefDottedKey"
      [selectionMode]="selectionMode"
      [selectMultiple]="selectMultiple"
      [enableSuggestions]="enableSuggestions"
      [initialSuggestions]="initialSuggestions"
      [initialValue]="initialValue"
      [id]="id"
      [disabled]="readonly"
      [autoFocus]="true"
      (concept)="onConceptChanged($event)"
      (suggestions)="onSuggestionsChanged($event)"
    ></med-thesaurus-tree-single>
  }
</ng-template>
<ng-template #multiple>
  @if (thesaurusDefDottedKey) {
    <med-thesaurus-tree-multiple
      [thesaurusDefDottedKey]="thesaurusDefDottedKey"
      [selectionMode]="selectionMode"
      [selectMultiple]="selectMultiple"
      [enableSuggestions]="enableSuggestions"
      [initialTags]="initialTags"
      [initialSuggestions]="initialSuggestions"
      [id]="id"
      [disabled]="readonly"
      [autoFocus]="true"
      (concepts)="onConceptsChanged($event)"
      (suggestions)="onSuggestionsChanged($event)"
    ></med-thesaurus-tree-multiple>
  }
</ng-template>
